import dayjs from "dayjs";
import { useManagementSubscriptionContext } from "./Context";

const Step4 = () => {
  const {
    setShouldShowCancelSubscriptionStep,
    subsWillBeCancelled,
    activePricePlan,
    subscriptionPlan,
    isButtonDisabled,
    onRenewSubscription,
    onCancelSubscription,
    onCancelSubscriptionModal,
  } = useManagementSubscriptionContext();

  return (
    <div data-name={"modal-step-4"} className={"h-full grow flex flex-col"}>
      <div className={"scroll-wrapper grow"}>
        <div className={"mb-10"}>
          <div
            className={
              "text-dark-1 text-center font-jost text-xl font-semibold leading-6.5 mb-1.5 lg:text-[28px] lg:leading-8"
            }>
            {subsWillBeCancelled ? "Renew your subscription" : "Cancel your subscription"}
          </div>
        </div>

        <div className="w-full lg:max-w-[480px] lg:mx-auto lg:pt-8 lg:pb-6 lg:px-6 lg:rounded-lg lg:bg-gray-4">
          <div className={" text-gray-1 uppercase text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
            Current subscription
          </div>
          <hr className="my-3" />
          <div className="min-h-28 flex flex-col lg:flex-row gap-4">
            <div className={""}>
              <h3 className="text-gray-1 text-left text-base font-semibold leading-5.5 !mb-0 lg:text-lg lg:leading-6">
                {subscriptionPlan.name}
              </h3>
              <div className="flex items-center mt-1">
                <span className="text-dark-1 font-jost font-bold text-[28px] leading-8 lg:text-[32px] lg:leading-10">
                  £{activePricePlan.unit_amount / 100}
                  <span className={"text-gray-1 font-jost text-base font-medium leading-5.5"}>
                    /{subscriptionPlan.interval}
                  </span>
                </span>
              </div>
              <div className="text-secondary font-jost mt-4 text-sm font-normal leading-5">
                {subsWillBeCancelled
                  ? "This subscription will no longer be cancelled. It will renew on"
                  : "Your subscription will be cancelled, but is still available until the end of your billing period on"}{" "}
                {dayjs(subscriptionPlan.current_period_end * 1000).format("DD MMMM YYYY")}.
              </div>
              {!subsWillBeCancelled && (
                <div className="text-secondary font-jost mt-4 text-sm font-normal leading-5">
                  If you change your mind, <span className={"font-medium"}>you can renew your subscription</span>.
                </div>
              )}

              <div className={"py-12 flex flex-col gap-4 px-7"}>
                {subsWillBeCancelled && (
                  <div className="text-secondary font-jost text-xs font-normal">
                    By renewing your subscription, you agree to BEST OF THE BEST's{" "}
                    <a
                      target="_blank"
                      href="https://www.botb.com/terms"
                      title={"Terms of Service"}
                      className={"!underline text-dark-3 font-medium"}>
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a
                      target="_blank"
                      href="https://www.botb.com/privacy"
                      title={"Privacy Policy"}
                      className={"!underline text-dark-3 font-medium"}>
                      Privacy Policy
                    </a>
                  </div>
                )}

                <button
                  disabled={isButtonDisabled}
                  onClick={subsWillBeCancelled ? onRenewSubscription : onCancelSubscription}
                  className={"theme-btn theme-btn-primary theme-btn-md uppercase max-lg:w-full"}>
                  {subsWillBeCancelled ? "Renew subscription" : "Cancel subscription"}
                </button>
                <button
                  onClick={onCancelSubscriptionModal}
                  className={"theme-btn theme-btn-md uppercase max-lg:w-full text-primary"}>
                  Keep subscription
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
